// extracted by mini-css-extract-plugin
export default {"page":"page__30b94145","header":"header__30b94145","tab":"tab__30b94145","content":"content__30b94145"};